<template>
	<v-dialog v-model="show" max-width="1000" persistent>
		<v-card>
			<v-card-title class="primary lighten white--text">
				Configurações de Projetos
				<v-spacer></v-spacer>
				<v-btn text class="white--text" @click="closeModal()">
					<v-icon white>mdi-window-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-tabs v-model="settings_tab" background-color="transparent" color="primary" grow>
					<v-tab>Prazos</v-tab>
					<v-tab>Notificações Global</v-tab>
				</v-tabs>
				<v-tabs-items v-model="settings_tab">
					<v-tab-item>
						<v-container fluid>
							<!-- Conteúdo da aba Prazos -->
							<v-row>
								<v-col cols="12">
									<v-card style="border-radius: 20px">
										<v-row style="align-items: center;">
											<v-col cols="6" class="d-flex align-center pa-0">
												<v-card-title class="title-displays mb-0">Datas</v-card-title>
											</v-col>
											<v-col cols="6" class="d-flex justify-end align-center pa-0">
												<v-btn @click="addNewDate()" text style="color: #1976d2; font-weight: bold; text-transform: uppercase; letter-spacing: 1px; margin-right: 0;">
													ADICIONAR
													<v-icon right small>mdi-plus</v-icon>
												</v-btn>
											</v-col>
										</v-row>

										<v-row class="mt-0" style="align-items: flex-end;">
											<v-col cols="9">
												<v-text-field class="px-4" prepend-icon="search" label="Busca"
													v-model="datesSearchText"></v-text-field>
											</v-col>
											<v-col cols="3">
												<v-select hint="Buscar nessa coluna" persistent-hint
													v-model="datesColumnToSearch" :items="datesColumnsToChoose" return-object single-line label="Nome"></v-select>
											</v-col>
										</v-row>

										<v-data-table :loading="datesLoading.mainTable" :items="filteredDatesItems" :headers="datesHeaders" :footer-props="{
											'items-per-page-options': [5, 10, 20, 30]
										}" no-data-text="Sem Dados para exibir" class="px-4">

											<template v-slot:item.actions="{ item }">
												<div class="d-flex align-center justify-center" style="gap: 8px;">
													<v-icon small color="primary" @click="selectDateAction(item, 'edit')" style="cursor:pointer;">mdi-pencil</v-icon>
													<v-icon small color="primary" @click="selectDateAction(item, 'delete')" style="cursor:pointer;">mdi-delete</v-icon>
												</div>
											</template>
										</v-data-table>
									</v-card>
								</v-col>
							</v-row>

							<!-- Modal para adicionar/editar data -->
							<v-dialog transition="dialog-bottom-transition" max-width="800" v-model="datesModalDate">
								<v-card>
									<v-card-title class="primary lighten white--text">{{ datesModalTitle }}
										<v-spacer></v-spacer>
										<v-btn text class="white--text" @click="closeDateModal()">
											<v-icon white>mdi-window-close</v-icon>
										</v-btn>
									</v-card-title>
									<v-card-text>
										<v-form ref="dateForm" lazy-validation>
											<v-row>
												<v-col cols="12">
													<v-text-field label="Nome da Data" v-model="datesEditedItem.name" placeholder="Nome"
														:rules="datesRulesRequired"></v-text-field>
												</v-col>
												<v-col cols="6">
													<v-text-field
														label="Data Mínima"
														v-model="datesEditedItem.minDate"
														type="number"
														placeholder="Data mínima"
														:rules="datesRulesRequired"
													></v-text-field>
												</v-col>
												<v-col cols="6">
													<v-text-field
														label="Data Máxima"
														v-model="datesEditedItem.maxDate"
														type="number"
														placeholder="Data máxima"
														:rules="datesRulesRequired"
													></v-text-field>
												</v-col>
											</v-row>
										</v-form>
									</v-card-text>
									<v-card-actions class="justify-end">
										<v-btn :loading="datesLoading.modalDate" text @click="saveDate()">
											{{datesModalTitle == "Editar Data"? 'Editar':'Salvar'}}
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</v-container>
					</v-tab-item>
					<v-tab-item>
						<v-container fluid>
							<!-- Conteúdo da aba Notificações Global -->
							<v-card outlined class="mt-4">
								<v-card-title class="subtitle-2 grey lighten-4">
									<v-icon left small>mdi-account-multiple</v-icon>
									Lista de Franqueados
									<v-spacer></v-spacer>
									<v-text-field
										v-model="localSearch"
										prepend-icon="search"
										label="Buscar Franqueado"
										dense
										solo
										style="max-width: 300px"
									/>
								</v-card-title>
								<v-divider></v-divider>
								<v-list dense>
									<v-list-item
										v-for="franq in filteredFranchisees"
										:key="franq.id"
										class="px-4"
									>
										<v-list-item-avatar>
											<v-icon color="primary">mdi-account-circle</v-icon>
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title>{{ franq.name }}</v-list-item-title>
										</v-list-item-content>
										<v-list-item-action>
											<v-btn icon color="primary" @click="openFranchiseeConfig(franq)">
												<v-icon>mdi-cog</v-icon>
											</v-btn>
										</v-list-item-action>
									</v-list-item>
								</v-list>
							</v-card>

							<!-- Modal de configuração de receptores globais do franqueado -->
							<v-dialog v-model="localDialog" max-width="700px" persistent>
								<v-card>
									<v-card-title class="primary lighten white--text">
										Configuração Global de Notificações - {{ localSelectedFranchisee ? localSelectedFranchisee.name : '' }}
										<v-spacer></v-spacer>
										<v-btn text class="white--text" @click="closeFranchiseeConfig()">
											<v-icon white>mdi-window-close</v-icon>
										</v-btn>
									</v-card-title>
									<v-card-text>
										<NotificationReceptors
											:key="localSelectedFranchisee ? localSelectedFranchisee.id : 'no-franq'"
											v-model="selectedFranchiseeReceptors"
											:notificationReceptorsList="allUsersList"
											:isLoading="isLoadingReceptors"
											:savingConfigsLoading="savingFranchiseeConfig"
											:getReceptorById="getReceptorByIdGlobal"
											:getReceptorAlertsCount="getReceptorAlertsCountGlobal"
											@save="saveFranchiseeReceptors(selectedFranchiseeReceptors)"
											@config="openFranchiseeReceptorConfig"
										/>
									</v-card-text>
								</v-card>
							</v-dialog>

							<!-- Modal de configuração de alertas por receptor global -->
							<NotificationReceptorConfig
								v-if="currentFranchiseeReceptorConfig"
								v-model="franchiseeReceptorConfigDialog"
								:receptorId="currentFranchiseeReceptorConfig.id"
								:receptorName="currentFranchiseeReceptorConfig.name"
								:currentStatuses="currentFranchiseeReceptorConfig.statuses"
								@save="saveFranchiseeReceptorConfig"
								@close="franchiseeReceptorConfigDialog = false"
							/>
						</v-container>

					</v-tab-item>
				</v-tabs-items>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper";
import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
import DatesService from "@/services/firebase/Dates/DatesService";
import Rules from "@/utils/Rules";
import NotificationReceptorConfig from '@/components/Projects/NotificationReceptorConfig.vue';
import NotificationReceptors from "../../components/Projects/NotificationReceptors.vue";
import UsersService from "@/services/firebase/Users/UsersService";
import ProjectsNotifyConfigService from "@/services/firebase/ProjectsNotifyConfig/ProjectsNotifyConfigService";

export default {
	name: "ProjectSettingsModal",

	components: {
		NotificationReceptorConfig,
		NotificationReceptors,
	},

	props: {
		show: {
			type: Boolean,
			default: false
		},
		// Franqueados para configuração global
		franchiseeList: {
			type: Array,
			default: () => []
		},
	},
	data() {
		return {

			settings_tab: 0,
			// Para configuração global de notificações por franqueado
			// 🔥 Controle interno do modal
			localDialog: false,
			localSearch: '',
			localSelectedFranchisee: null,

			 // 🔐 Config isolada por franqueado
			franchiseeConfig: {
				// Novo formato: { [receptorId]: [...statuses] }
				notification_receptors: {}
			},
			franchiseeConfigsCache: {}, // cache para configs de cada franqueado
			
			selectedFranchiseeReceptors: [],
			
			// 🔒 Backup igual ProjectDetail
			configBackup: null,
			configWasSaved: false,
			
			allUsersList: [], // Lista de todos usuários possíveis receptores
			isLoadingReceptors: false,
			savingFranchiseeConfig: false,

			franchiseeReceptorConfigDialog: false,
			currentFranchiseeReceptorConfig: null,
			// Propriedades para gerenciamento de datas
			datesData: [],
			datesSearchText: "",
			datesColumnToSearch: "name",
			datesColumnsToChoose: [{ value: "name", text: "Nome" }],
			datesModalDate: false,
			datesModalTitle: "Adicionar Data",
			datesEditedItem: {
				name: '',
				minDate: null,
				maxDate: null,
				deletedAt: null
			},
			datesLoading: {
				modalDate: false,
				mainTable: false,
				buttonList: false,
			},
			datesHeaders: [
				{ text: "Nome", value: "name", },
				{ text: "Data Mínima", value: "minDate", class: 'text-center', align: 'center' },
				{ text: "Data Máxima", value: "maxDate", class: 'text-center', align: 'center' },
				{ text: 'Ações', value: 'actions', sortable: false, class: 'text-center', align: 'center' },
			],
		}
	},
	computed: {
		
		filteredFranchisees() {
			return this.franchiseeList.filter(franq =>
				franq.name.toLowerCase().includes(this.localSearch.toLowerCase())
			);
		},
		filteredDatesItems() {
			return this.datesData
				.filter(date => !date.deletedAt) // Filtrar apenas datas não deletadas
				.filter(i => 
					i[this.datesColumnToSearch].toLowerCase().includes(this.datesSearchText.toLowerCase())
				);
		},
		datesRulesRequired() {
			return Rules.required();
		},
	},
	watch: {
		show(newVal) {
			if (newVal) {
				this.loadDatesData();
			}
		},
		localDialog(newVal, oldVal) {
			if (!newVal && oldVal && !this.configWasSaved) {
				if (this.configBackup) {
					this.franchiseeConfig.notification_receptors =
						JSON.parse(JSON.stringify(
							this.configBackup.notification_receptors
						));

					this.selectedFranchiseeReceptors =
						[...this.configBackup.selected_ids];

					this.configBackup = null;
				}
			}
			if (!newVal && oldVal && this.configWasSaved) {
				this.configBackup = null;
				this.configWasSaved = false;
			}
		}
	},
	methods: {
		async getNotificationReceptors() {
            try {
                const ranks = [0, 1];
                const allUsers = [];
                
                for (const rank of ranks) {
                    const users = await UsersService.getUsersByRank(rank);
                    if (users && users.length > 0) {
                        allUsers.push(...users);
                    }
                }
                
                this.allUsersList = allUsers.map(user => ({
                    id: user.id,
                    name: user.name,
					text: `${user.name}`,
                }));
            } catch (error) { 
				console.error('Error fetching users:', error);
				showErrorSnackBar('Erro ao carregar usuários para notificações');
			}
		},
		// --- Funções para configuração global de notificações por franqueado (repetidas de ProjectDetails.vue) ---
		async openFranchiseeConfig(franq) {
			// Limpa estado antes de carregar
			this.franchiseeConfig = { notification_receptors: {} };
			this.selectedFranchiseeReceptors = [];
			this.configWasSaved = false;

			try {
				this.isLoadingReceptors = true;

				// Busca configs do cache ou do banco
				let config = this.franchiseeConfigsCache[franq.id];
				if (!config) {
					config = await ProjectsNotifyConfigService.getProjectNotifyConfig(franq.id);
					this.franchiseeConfigsCache[franq.id] = config || { notification_receptors: [] };
				}

				if (config && config.notification_receptors) {
					this.franchiseeConfig.notification_receptors = JSON.parse(JSON.stringify(config.notification_receptors));
				} else {
					this.franchiseeConfig.notification_receptors = {};
				}

				// IDs para o autocomplete (chaves do mapa)
				this.selectedFranchiseeReceptors = Object.keys(this.franchiseeConfig.notification_receptors);

				// 🔒 Backup
				this.configBackup = JSON.parse(JSON.stringify({
					notification_receptors: this.franchiseeConfig.notification_receptors,
					selected_ids: [...this.selectedFranchiseeReceptors]
				}));

			} catch (error) {
				showErrorSnackBar("Erro ao carregar configuração");
			} finally {
				this.isLoadingReceptors = false;
				// Só define o franqueado selecionado e abre o modal
				// depois que os dados já estiverem carregados,
				// garantindo que o componente filho receba o v-model correto ao montar.
				this.localSelectedFranchisee = franq;
				this.localDialog = true;
			}
		},

		closeFranchiseeConfig() {
			this.localDialog = false;
			this.localSelectedFranchisee = {};
			this.selectedFranchiseeReceptors = [];
		},
		getReceptorByIdGlobal(receptorId) {
			return this.allUsersList.find(r => r.id === receptorId) || null;
		},
		getReceptorAlertsCountGlobal(receptorId) {
			const statuses = this.franchiseeConfig.notification_receptors
				? this.franchiseeConfig.notification_receptors[receptorId]
				: null;

			return Array.isArray(statuses) ? statuses.length : 0;
		},
		openFranchiseeReceptorConfig(receptorId) {
			const receptor = this.getReceptorByIdGlobal(receptorId);
			if (!receptor) return;
			// Busca configuração atual do receptor global para o franqueado
			const statuses = this.franchiseeConfig.notification_receptors
				? this.franchiseeConfig.notification_receptors[receptorId]
				: null;
			this.currentFranchiseeReceptorConfig = {
				id: receptorId,
				name: receptor.name,
				statuses: Array.isArray(statuses) ? [...statuses] : [],
			};
			this.franchiseeReceptorConfigDialog = true;
		},
		saveFranchiseeReceptorConfig(config) {
			const { receptorId, statuses } = config;

			if (!this.franchiseeConfig.notification_receptors) {
				this.franchiseeConfig.notification_receptors = {};
			}

			this.franchiseeConfig.notification_receptors[receptorId] = Array.isArray(statuses)
				? [...statuses]
				: [];
			showSuccessSnackBar("Notificações atualizados!");
			this.franchiseeReceptorConfigDialog = false;
		},
		async saveFranchiseeReceptors(selectedIds) {
			if (!this.localSelectedFranchisee) return;

			if (selectedIds.length > 5) {
				showErrorSnackBar("Máximo de 5 receptores por franqueado");
				return;
			}
			this.savingFranchiseeConfig = true;
			try {
				// Mantém configs existentes dos receptores já salvos
				const current = this.franchiseeConfig.notification_receptors || {};

				const receptorsData = {};
				selectedIds.forEach((id) => {
					if (current[id]) {
						receptorsData[id] = Array.isArray(current[id]) ? [...current[id]] : [];
					} else {
						receptorsData[id] = [];
					}
				});

				this.franchiseeConfig.notification_receptors = receptorsData;

				// Salva no banco
				await ProjectsNotifyConfigService.setProjectNotifyConfig(this.localSelectedFranchisee.id, { notification_receptors: receptorsData });

				// Atualiza cache
				this.franchiseeConfigsCache[this.localSelectedFranchisee.id] = {
					notification_receptors: JSON.parse(JSON.stringify(receptorsData))
				};

				showSuccessSnackBar("Configuração salva com sucesso!");
				this.configWasSaved = true;
				this.localDialog = false;
			} catch (error) {
				showErrorSnackBar("Erro ao salvar configuração");
			} finally {
				this.savingFranchiseeConfig = false;
			}
		},
		// --- Fim das funções repetidas ---
		closeModal() {
			this.$emit('close');
		},
		// Métodos para gerenciamento de datas
		async loadDatesData() {
			this.datesLoading.mainTable = true;
			try {
				this.datesData = await DatesService.getDates();
			} catch (error) {
				console.error('Error loading dates:', error);
				showErrorSnackBar('Erro ao carregar datas');
			} finally {
				this.datesLoading.mainTable = false;
			}
		},
		addNewDate() {
			this.datesModalTitle = "Adicionar Data";
			this.datesEditedItem = {
				name: '',
				minDate: null,
				maxDate: null,
				deletedAt: null
			};
			this.datesModalDate = true;
		},
		async selectDateAction(item, value) {
			switch (value) {
				case "edit":
					this.editDate(item);
					break;
				case "delete":
					this.datesEditedItem = { ...item };
					showDeleteDialogAlert(`Deseja excluir a data "${item.name}"?`, this.deleteDateConfirm);
					break;
			}
		},
		async editDate(item) {
			this.datesEditedItem = { ...item };
			this.datesModalTitle = "Editar Data";
			this.datesModalDate = true;
		},
		async deleteDateConfirm() {
			this.datesLoading.buttonList = true;
			try {
				await DatesService.editDate(this.datesEditedItem.id_doc, { deletedAt: new Date() });
				showSuccessSnackBar("Data deletada!");
				this.datesData = this.datesData.filter((date) => date.id_doc != this.datesEditedItem.id_doc);
				this.closeDateModal();
			} catch (error) {
				console.error('Error deleting date:', error);
				showErrorSnackBar('Erro ao deletar data');
			} finally {
				this.datesLoading.buttonList = false;
			}
		},
		async saveDate() {
			try {
				if ((this.$refs.dateForm) && !this.$refs.dateForm.validate()) return;
				this.datesLoading.modalDate = true;

				if (this.datesModalTitle === "Adicionar Data") {
					const newDateId = await DatesService.createDate(this.datesEditedItem);
					showSuccessSnackBar("Data criada!");
					this.datesData.unshift({ ...this.datesEditedItem, id_doc: newDateId });
				} else {
					await DatesService.editDate(this.datesEditedItem.id_doc, this.datesEditedItem);
					showSuccessSnackBar("Data editada!");
					this.datesData = this.datesData.map((date) => date.id_doc === this.datesEditedItem.id_doc ? this.datesEditedItem : date);
				}
				this.closeDateModal();
			} catch (error) {
				console.error('Error saving date:', error);
				showErrorSnackBar('Erro ao salvar data');
			} finally {
				this.datesLoading.modalDate = false;
			}
		},
		closeDateModal() {
			this.datesLoading.buttonList = false;
			this.datesModalDate = false;
			this.datesEditedItem = {
				name: '',
				minDate: null,
				maxDate: null,
				deletedAt: null
			};
		}
	},
	async created() {
		try{
			await this.getNotificationReceptors();
		} catch (error) {
			console.error('Error in created hook:', error);
		}	
	},
};
</script>

<style scoped>
.title-displays {
	font-size: 25px;
	padding-top: 8px;
	padding-bottom: 8px;
}
</style> 